import { render, staticRenderFns } from "./Category_product.vue?vue&type=template&id=3c77926d&scoped=true"
import script from "./Category_product.vue?vue&type=script&lang=js"
export * from "./Category_product.vue?vue&type=script&lang=js"
import style0 from "./Category_product.vue?vue&type=style&index=0&id=3c77926d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c77926d",
  null
  
)

export default component.exports